import { Component, computed, HostListener, input, signal } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { TelephoneLinkComponent } from '../../../../../../../../../../../../shared/components/telephone-link/telephone-link.component';
import { Breakpoints } from '../../../../../../../../../../../../shared/types/breakpoints';
import { MmrService } from '../../../../../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim } from '../../../../../../../../../../types/mmr-claims.type';

@Component({
  selector: 'app-out-card-left',
  imports: [TelephoneLinkComponent, DotPulseComponent],
  templateUrl: './out-card-left.component.html',
  styleUrl: './out-card-left.component.scss',
})
export class OutCardLeftComponent {
  claimType = input.required<'repair' | 'service'>();

  isMobile = signal(false);
  @HostListener('window:resize')
  onResize() {
    const isMobile = window.innerWidth < Breakpoints.sm;
    if (this.isMobile() !== isMobile) {
      this.isMobile.set(isMobile);
    }
  }

  protected viewModel = computed(() => {
    const claimsRequest = this.mmrService.planClaimsDetails.claims;
    const claims = claimsRequest?.value();
    const postCode = claims?.addressInformation?.postalCode;

    const claim = claims?.[this.claimType()] as ClaimDetailsPanelViewClaim;
    const phone = claim?.serviceProvider?.phone;

    return {
      postCode,
      phone,
      isMobile: this.isMobile(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
